import lightGallery from "lightgallery";
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgAutoplay from "lightgallery/plugins/autoplay";

var inline_gallery = (function($) {
    var _init = function() {
        display_gallery();
    };

    function display_gallery() {
        const lg_container = document.getElementById('inline-gallery-container');

        var gallery_data = $('#inline-gallery-container').data('gallery-images');

        if (typeof gallery_data === 'string') {
            try {
                gallery_data = JSON.parse(gallery_data);
            } catch (e) {
                console.error("Error parsing gallery data:", e);
                return;
            }
        }

        if (!Array.isArray(gallery_data)) {
            return;
        }

        const content_blocks_images = gallery_data.map(function(image) {
            return {
                src: image.src,
                thumb: image.thumb
            };
        });

        var inline_gallery = lightGallery(lg_container, {
            container: lg_container,
            dynamic: true,
            hash: false,
            closable: false,
            autoplay: true,
            zoom: true,
            download: true,
            showMaximizeIcon: true,
            appendSubHtmlTo: '.lg-item',
            slideDelay: 200,
            slideShowInterval: 5000,
            slideShowAutoplay: true,
            autoplayControls: true,
            controls: true,
            plugins: [lgZoom, lgThumbnail, lgAutoplay],
            dynamicEl: content_blocks_images,
            enableTouch: true,
        });

        setTimeout(function() {
            inline_gallery.openGallery();
        }, 200);
    }

    $(document).ready(_init);

    return {};
})(jQuery);

export default inline_gallery;